import { PermitSitePhotosTabActionTypes, ADD_SITE_PHOTO, DELETE_SITE_PHOTO } from "./types";
import { Permit } from "../../models/Permit";
import { PermitState } from "../PermitContainer/types";
import { Guid } from "guid-typescript";
import { ISSUED, READY_TO_ISSUE } from "../../constants";
import { SitePhotoTypes } from "../../SitePhotoService";

const reducer = (state: PermitState, action: PermitSitePhotosTabActionTypes) => {
    switch (action.type) {
        case ADD_SITE_PHOTO:
            const type =
                state.permit?.status === READY_TO_ISSUE
                    ? SitePhotoTypes.Issue
                    : state.permit?.status === ISSUED
                    ? SitePhotoTypes.WorkProgress
                    : "";
            return {
                ...state,
                permit: {
                    ...state.permit,
                    sitePhotos: [
                        ...(state.permit?.sitePhotos ? state.permit.sitePhotos : []),
                        {
                            id: Guid.create().toString(),
                            type: {
                                key: type ? type.key : "",
                                name: type ? type.name : "",
                            },
                            fileKey: action.sitePhotoFileKey,
                            createdById: action.createdById,
                            comments: action.comments,
                            dateCreated: new Date(),
                            pendingSync: true,
                        },
                    ],
                    pendingSave: true,
                } as Permit,
                newFiles: [...state.newFiles, action.photoFile],
            };
        case DELETE_SITE_PHOTO:
            return {
                ...state,
                permit: {
                    ...state.permit,
                    sitePhotos: state.permit?.sitePhotos?.map((sp) =>
                        sp.id === action.sitePhotoId ? { ...sp, pendingDelete: true } : { ...sp }
                    ),
                    pendingSave: true,
                } as Permit,
            };
        default:
            return state;
    }
};

export default reducer;
